import type { Match, Query } from '@atlassian/react-resource-router';
import { getProjectKeyId } from './getProjectKeyId.tsx';

export const getProjectKeyOrId = (match: Match): string => {
	const { projectKey, projectId } = getProjectKeyId(match, match.query);
	return projectKey || projectId || '';
};

export const getProjectKeyOrIdFromMatchAndQuery = ({
	match,
	query,
}: {
	match: Match;
	query: Query;
}): string => {
	const { projectKey, projectId } = getProjectKeyId(match, query);
	return projectKey || projectId;
};
